<template>
  <div>
    <page-intro>
      <template v-slot:heading>Выставленные счета</template>
      <template v-slot:info>
        <div class="mb-24">Оплата услуг аренды 1С</div>
        <div class="text-medium">
          <div>Текущий баланс: {{ formatNumber(balance, 'currency') }}</div>
          <div>Ежемесячный платеж: {{ formatNumber(monthlyPayment, 'currency') }}</div>
        </div>
      </template>
      <template v-slot:controls>
        <div class="mb-20">
          <el-button
            type="primary"
            class="w-100 mb-20 ml-0"
            :disabled="!$store.state.user.accInfo.isAdmin"
            @click="showBillingModal = true">
            Выставить счет
          </el-button>
          <instruction-link name="payments">Инструкция по платежам</instruction-link>
        </div>
      </template>
    </page-intro>
    <invoices-list ref="invoices" />
    <invoices-modal :visible.sync="showBillingModal" @update-list="updateInvoices" />
  </div>
</template>

<script>
  import PageIntro from '@/components/PageIntro.vue'
  import InstructionLink from '@/components/InstructionLink.vue'
  import InvoicesList from './InvoicesList.vue'
  import InvoicesModal from './InvoicesModal.vue'
  import { formatNumber } from '@/utils'

  export default {
    components: {
      PageIntro,
      InvoicesList,
      InvoicesModal,
      InstructionLink
    },

    data() {
      return {
        showBillingModal: false
      }
    },

    computed: {
      balance() {
        return this.$store.state.user.accInfo.balance || 0
      },
      monthlyPayment() {
        return this.$store.state.user.accInfo.monthlyPayment || 0
      }
    },

    methods: {
      updateInvoices() {
        this.$refs.invoices.getInvoices()
      },
      formatNumber
    }
  }
</script>